import { render, staticRenderFns } from "./manageTraining.vue?vue&type=template&id=4602b8b2&"
import script from "./manageTraining.vue?vue&type=script&lang=js&"
export * from "./manageTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports